import { Button, Form, Input, message } from 'antd'
import type { FormProps } from 'antd'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { AUTH_KEY, REF_CODE, TOKEN_KEY } from '~/constants/storage'
import { login } from '~/services/login'

import Animation from './Animation'
import { Container } from './style'
import './style.css'

const Index = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const onFinish = useCallback<
    Required<FormProps<{ username: string; password: string }>>['onFinish']
  >(
    (value) => {
      setLoading(true)
      login(value.username, value.password)
        .then((res) => {
          localStorage.setItem(TOKEN_KEY, `Bearer ${res.data.token}`)
          localStorage.setItem(AUTH_KEY, res.data.authorities)
          if (res.data.refCode) {
            localStorage.setItem(REF_CODE, res.data.refCode)
          }
          message.success('登录成功')
          navigate('/home/overview')
        })
        .catch((err) => {
          message.error(err?.response?.data || err?.message || '登录失败')
        })
        .finally(() => {
          setLoading(false)
        })
    },
    [navigate],
  )

  return (
    <Container>
      <div className="animation">
        <Animation />
      </div>
      <div className="top">
        <div className="content">
          <div className="icon">SC</div>
          <div className="title">Shaokai-Chasing admin</div>
        </div>
      </div>
      <div className="middle">
        <div className="login-wrap">
          <div className="title">登录</div>
          <div className="form">
            <Form
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              autoComplete="off"
              onFinish={onFinish}
            >
              <Form.Item
                label="用户名"
                name="username"
                rules={[{ required: true, message: '请输入用户名' }]}
                // initialValue="john.doe@example.com"
              >
                <Input placeholder="经销商填写手机号" />
              </Form.Item>
              <Form.Item
                label="密码"
                name="password"
                rules={[{ required: true, message: '请输入密码' }]}
                // initialValue="A1XZxWVoQL0LLioK"
              >
                <Input.Password />
              </Form.Item>
              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  登录
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
      <div className="bottom">
        沪ICP备2024096443号-1 Copyright © 2024 韶凯世桥科技
      </div>
    </Container>
  )
}

export default Index
